import parseToken from './parseToken';

// compare expiration date with current date
const isAccessTokenValid = (token: string | null): boolean =>
  new Date().getTime() / 1000 + 60 < parseToken(token)?.exp;

export default isAccessTokenValid;
